import { PrivilegeChecker, Config } from 'omni-common-ui';
import is from 'is_js';
import Privileges from 'domain/Privileges';
import TabSwitcher, { TabCodes } from 'domain/TabSwitcher';
import ViewNav from 'components/ViewNav';
import IndividualDevelopmentPlan from './component';
import { routes as individualDevelopmentPlanListView } from './IndividualDevelopmentPlanListView';
import { routes as individualDevelopmentPlanDetailView } from './IndividualDevelopmentPlanDetailView';
import { routes as individualDevelopmentPlanApprovalView } from './IndividualDevelopmentPlanApprovalView';
import { accessors as idpAccessors } from 'data/IndividualDevelopmentPlans';
import { accessors as centreAccessors } from 'data/Centre';
import { actions as groupActions } from 'containers/Group';

const enableIdpForAllBU = () => Config.get('enableIndividualDevelopmentPlanForAllBU');

const secondLevelTabs = (getState, { groupId, groupIdpId }, push, buildRoute) => {
  let groupIdpList = idpAccessors.getGroupIdpList(getState(), groupId);
  if (groupIdpList.size <= 1) return [];
  groupIdpList = groupIdpList.toList();
  return groupIdpList.map((groupIdpInfo) => ({
    text: groupIdpInfo.name.toUpperCase(),
    onClick: () => push(buildRoute(`/group/${groupId}/progress-report/${groupIdpInfo.id}`)),
    isActive: groupIdpId === groupIdpInfo.id.toString(),
  })).toArray();
};

export const isRUCentreChecker = (state, groupId) => {
  const groupInfo = groupActions.getGroup(state, groupId);
  if (! groupInfo) return;
  const isRUCentre = centreAccessors.isRUCentre(state, groupInfo.centreId);
  if (is.undefined(isRUCentre)) return;
  return isRUCentre;
};

export const shouldEnableIdp = (state, groupId) => {
  const isTabEnabled = TabSwitcher.isTabEnabled(state, groupId, TabCodes.IDP);
  const isRUCentre = isRUCentreChecker(state, groupId);
  if (is.undefined(isRUCentre)) return true;
  return isTabEnabled && (isRUCentre || enableIdpForAllBU());
};

export default ({ getState }) => ({
  appBars: {
    sticky: {
      'view-nav': {
        component: ViewNav,
        order: 2,
        props: {
          hideExpandable: true,
        },
      },
    },
  },
  path: 'progress-report',
  component: IndividualDevelopmentPlan,
  secondLevelTabs: ({ push, params, buildRoute }) =>
    secondLevelTabs(getState, params, push, buildRoute),
  breadcrumbLabels: ({ params, buildRoute }) => ({
    label: idpAccessors.getReportName(getState(), params.groupIdpId, 'progress report'),
    href: buildRoute(buildRoute(`/group/${params.groupId}/progress-report/${params.groupIdpId}`)),
  }),
  canAccess: ({ params }) =>
    PrivilegeChecker.hasPrivilege(getState(), Privileges.IndividualDevelopmentPlan.View) &&
    shouldEnableIdp(getState(), params.groupId),
  childRoutes: [
    individualDevelopmentPlanApprovalView,
    individualDevelopmentPlanListView,
    individualDevelopmentPlanDetailView,
  ],
  tab: {
    label: (params) => (groupActions.isDisabledReportActions(getState(), params.groupId) ?
      'Historical Progress Reports' :
      'Progress Reports'),
    order: 10,
    isVisible: (params) =>
      PrivilegeChecker.hasPrivilege(getState(), Privileges.IndividualDevelopmentPlan.View) &&
      shouldEnableIdp(getState(), params.groupId),
  },
});



// WEBPACK FOOTER //
// ./containers/Group/IndividualDevelopmentPlan/routes.js